import { getSpaceCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { isWhite, size, alignment, padding  } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#sbbSkypeButton-${clientId}{
			text-align: ${alignment};
		}
		#sbbSkypeButton-${clientId} .sbbSkypeButton{
			font-size: ${size}px;
			padding: ${getSpaceCSS(padding)};
		}
		#sbbSkypeButton-${clientId} .sbbSkypeButton span{
			color: ${isWhite ? '#fff': '#00aff0'};
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;